import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#1E5631] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              {/* REMOVED the div with bg-[#4CAF50] */}
              <img 
                src="/logo.png" 
                alt="Logo" 
                style={{ height: '80px' }} /* Increased height slightly for visibility */
              />
              <span className="font-heading text-xl font-bold">Udyaan</span>
            </div>
            <p className="text-green-100 mb-4 leading-relaxed">
              Creating Sustainable Green Spaces
            </p>
            <p className="text-green-200 text-sm mb-6">
              Professional landscaping and horticulture services for residential, commercial, and industrial spaces.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#4CAF50] flex items-center justify-center hover:bg-[#45a049] transition-colors duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#4CAF50] flex items-center justify-center hover:bg-[#45a049] transition-colors duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#4CAF50] flex items-center justify-center hover:bg-[#45a049] transition-colors duration-300"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-green-100 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-green-100 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-green-100 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-green-100 hover:text-white transition-colors">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-green-100 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-green-100 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-3">
              <li className="text-green-100">Landscape Design & Planning</li>
              <li className="text-green-100">Garden Development</li>
              <li className="text-green-100">Horticulture & Plantation</li>
              <li className="text-green-100">Lawn Management</li>
              <li className="text-green-100">Irrigation Systems</li>
              <li className="text-green-100">Landscape Maintenance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#4CAF50] mt-1 flex-shrink-0" />
                <span className="text-green-100">
                  Gajraula, Uttar Pradesh, India
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#4CAF50] flex-shrink-0" />
                <a href="tel:+917984696638" className="text-green-100 hover:text-white transition-colors">
                  +91-7984696638
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#4CAF50] flex-shrink-0" />
                <a href="mailto:contact@udyaanlandscaping.com" className="text-green-100 hover:text-white transition-colors">
                  contact@udyaanlandscaping.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-green-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-green-100 text-sm">
              © 2024 Udyaan Landscaping Pvt Ltd. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-green-100 hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-green-100 hover:text-white transition-colors">
                Terms & Conditions
              </a>
              <a href="#" className="text-green-100 hover:text-white transition-colors">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
